export class GcpOptionalCapabilities {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enableGcsNotificationManagement",
            "baseName": "enableGcsNotificationManagement",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableBigqueryAutoChangeHistory",
            "baseName": "enableBigqueryAutoChangeHistory",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableGoogleWorkspace",
            "baseName": "enableGoogleWorkspace",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpOptionalCapabilities.attributeTypeMap;
    }
    constructor() {
    }
}
